import { Injectable } from '@angular/core';
import { StaticInfo } from '../app/_helpers/static-info';

@Injectable({
  providedIn: 'root'
})
export class InternationalAddressService {

  isForeignCountry: boolean = false;
  staticInfo_usa = new StaticInfo().countryCode.usa

  isClaimInternational(countryFromClaim:string){
    this.isForeignCountry = (countryFromClaim != this.staticInfo_usa)
  }

  public isMemberEligibleForClaimsDataCollectionConsent(productCode: string, countryCode: string, cuContractNumber: string, zipCode: string){
      if (this.getConsentProducts().includes(productCode)){
          if(this.getConsentCUs().includes(cuContractNumber)){
              if(countryCode ==="USA"){
                  if(zipCode.length>=3)
                    return this.getConsentUSAZips().includes(zipCode.substring(0,3))
              } else
                  return this.getConsentCountries().includes(countryCode);
          }
      }
      return false;
    }

    private getConsentCUs(): string[]{
        return ["02800392"]
    }
    private getConsentProducts(): string[]{
        return ["Disability"]
    }

    private getConsentUSAZips(): string[]{
        return ["090","091","092","096","097"]
    }
    
    private getConsentCountries(): string[]{
        return [
        "AUS",
        "BEL",
        "BGR",
        "CYP",
        "CZE",
        "HRV",
        "DNK",
        "EST",
        "FIN",
        "FRA",
        "DEU",
        "GRC",
        "HUN",
        "IRL",
        "ITA",
        "LTU",
        "LUX",
        "LVA",
        "MLT",
        "NLD",
        "POL",
        "PRT",
        "ROU",
        "SVK",
        "SVN",
        "ESP",
        "SWE"]
    }

  constructor() { }
}
